module.exports = __webpack_public_path__ + "media/components/breakheader/static/icon--heart-a364c82109464f172e320a0fda180fb8.svg";